import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Title, Section, Box, Text } from "../../components/Core";
import { Link } from "gatsby";

const SectionStyled = styled(Section)``;

const FaqCard = ({ title, children, ...rest }) => (
  <Box {...rest}>
    <Title variant="card" mb={4} fontSize="24px" fontWeight="500" color="dark">
      {title}
    </Title>
    <Text variant="small" color="lightShade">
      {children}
    </Text>
  </Box>
);

const FAQ = ({document}) => (
  <>
    <SectionStyled bg="white">
      <Container>
        <Row className="justify-content-center">
          <Col xl="7" lg="8" md="9">
            <div className="text-center ">
              <Title color="dark">How We Help</Title>
            </div>
          </Col>
        </Row>
        <Row className="pt-4">
          {document.map((item, index) => (
            <Col lg="6" className="mt-5">
              <FaqCard
                title={item.title.text}
              ></FaqCard>
            </Col>
          ))}



          <Col lg="12" className="">
            <Box className="text-center" pt={5}>
              <Text variant="small" color="dark">
                Need help with something else?{" "}
                <Link
                  to="/contact"
                  css={`
                    color: ${({ theme }) => theme.colors.primary} !important;
                  `}
                >
                  Contact us here
                </Link>
              </Text>
            </Box>
          </Col>
        </Row>
      </Container>
    </SectionStyled>
  </>
);

export default FAQ;
